import { MenuItem } from "@material-ui/core";
import { divide, multiply, sum } from "lodash";
import { requests } from "./requests";
import { baseURL, moduleURL } from "./http/config";

export const filterData = (
  array,
  field,
  compareValue,
  getSingleObj,
  yearToCompare
) => {
  if (
    array &&
    array.length > 0 &&
    field &&
    (compareValue || compareValue === false)
  ) {
    const filteredData = array.filter((singleObj) => {
      if (singleObj[field] || singleObj[field] === false) {
        return singleObj[field] === compareValue;
      } else {
        return false;
      }
    });
    if (filteredData && filteredData.length > 0 && filteredData[0]) {
      if (getSingleObj) {
        return filteredData[0];
      } else {
        return filteredData;
      }
    }
  } else if (array && array.length > 0 && field) {
    const filteredData = array.filter((singleObj) => {
      if (singleObj[field]) {
        return singleObj[field];
      } else {
        return false;
      }
    });
    if (filteredData && filteredData.length > 0 && filteredData[0]) {
      if (getSingleObj) {
        return filteredData[0];
      } else {
        return filteredData;
      }
    }
  }
};
export const listItemDropdown = (array, field, content) => {
  return array && array.length > 0 ? (
    content
  ) : (
    <MenuItem
      disabled={true}
      key={`No ${field} added yet`}
      value={`No ${field} added yet`}
      id={`No ${field} added yet`}
    >
      {`No ${field} added yet`}
    </MenuItem>
  );
};
export const StopScroll = (e) => {
  e.target.addEventListener(
    "wheel",
    function (e) {
      e.preventDefault();
    },
    { passive: false }
  );
};
export const scrollDiv = (id) => {
  const chat = document.getElementById(id);
  chat.scrollIntoView();
};
export const calculatePercentage = (originalAmount, percentage) => {
  return divide(
    multiply(
      originalAmount ? Number(originalAmount) : 0,
      percentage ? Number(percentage) : 0
    ),
    100
  );
};
export const calculateGstAmount = (
  originalAmount,
  percentage,
  percentageFrom
) => {
  return sum([
    calculatePercentage(
      percentageFrom ? percentageFrom : originalAmount,
      percentage
    ),
    originalAmount ? Number(originalAmount) : 0,
  ]);
};
export const calculateExchangeValue = (amount, rate) => {
  return multiply(amount ? Number(amount) : 0, rate ? Number(rate) : 0);
};
export const calculatePrice = (amount, weight) => {
  return divide(amount ? Number(amount) : 0, weight ? Number(weight) : 0);
};
export const getSingleModule_widget = (user, module_access, widget_access) => {
  const module_permission =
    user && user.user_accesses?.length > 0
      ? user.user_accesses[0].modules.find(
          (module) => module.module.module_name === module_access
        )
      : null;
  const widget_permission = module_permission
    ? module_permission.widgets.find(
        (it) => it.widget.widget_name === widget_access
      )
    : null;

  console.log(module_permission, widget_permission, "accessText.brands");
  return { module_permission, widget_permission };
};
export const getMinValue = (...args) => {
  if (args.length === 0) {
    throw new Error("At least one number must be provided");
  }

  let smallest = Number(args[0]);

  for (let i = 1; i < args.length; i++) {
    if (Number(args[i]) < smallest || smallest === 0) {
      if (args[i] !== 0) {
        smallest = Number(args[i]);
      }
    }
  }
  return smallest;
};

export const findMinValue = (...args) => {
  const validNumbers = args
    .map(Number)
    .filter(num => !isNaN(num) && Math.round(num) !== 0);

  if (validNumbers.length === 0) return 0;

  return Math.min(...validNumbers);
};
export const changeTo = (to, weigths, opposite) => {
  if (opposite) {
    if (to === "MT") {
      return multiply(weigths, 1000);
    } else if (to === "Kgs") {
      return weigths;
    } else if (to === "Qtl") {
      return multiply(weigths, 100);
    }
  } else {
    if (to === "MT") {
      return divide(weigths, 1000);
    } else if (to === "Kgs") {
      return weigths;
    } else if (to === "Qtl") {
      return divide(weigths, 100);
    }
  }
};
export const changeUnit = (from, to, weigths, opposite) => {
  //default in kg

  if (opposite) {
    if (from === "MT") {
      return changeTo(to, divide(weigths, 1000), opposite);
    } else if (from === "Kgs") {
      return changeTo(to, weigths);
    } else if (from === "Qtl") {
      return changeTo(to, divide(weigths, 100), opposite);
    }
  } else {
    if (from === "MT") {
      return changeTo(to, multiply(weigths, 1000));
    } else if (from === "Kgs") {
      return changeTo(to, weigths);
    } else if (from === "Qtl") {
      return changeTo(to, multiply(weigths, 100));
    }
  }
};

export const  quantityValue = (quantity) => {
  return(Number(quantity || 0).toFixed(3));
};
export const  RateValue = (quantity) => {
  return(Number(quantity || 0).toFixed(2));
};

export const CaptilizeText = (value) => {
  if (value) {
    let words = value.split(" ");
    // console.log(value, words)
    for (let i = 0; i < words.length; i++) {
      if (!isNaN(words[i])) continue;

      // console.log(words[i], words[i][0])
      words[i] = words[i]?.length == 2 ? words[i] : words[i][0]?.toUpperCase() + (words[i]?.substr(1))?.toLowerCase();
    }
    return words.join(" ");
  }
}

export const fetchRecursivePaginatedData = async (method, apiUrl, params = {}, type, handleCountStateUpdate, responseDataList = [], totalCount = 0, paymentSummary = null) => {
  let baseUrl = baseURL();
  console.log("regexs", method, apiUrl, params, type, handleCountStateUpdate, responseDataList , totalCount)
  try {
    let option = {
      method: method || 'get',
      url: type === "noForwordSlash"
      ? moduleURL(apiUrl,true)
      : moduleURL(apiUrl),
      
    }
    if(method === 'POST' || method === 'post'){
      option.data = params
    }
    else{
      option.params = params;
    }
    const response = await requests(option);
    console.log(method, apiUrl, params, handleCountStateUpdate, response)
    const count = response.data.total_count; 
    const newTotalCount = totalCount + response.data.results?.length;
    const nextPageUrl = response.data.next; 
    handleCountStateUpdate((newTotalCount / count) * 100)

    const newData = responseDataList.concat(response.data.results);
    const newPaymentSummary = response.data.payment_summary ?? paymentSummary;
    // If there is a next page, recursively fetch it
    if (nextPageUrl) {
      return fetchRecursivePaginatedData(
        method,
        nextPageUrl
        ? nextPageUrl?.includes(baseUrl) ? nextPageUrl.replace(baseUrl, "") : nextPageUrl
        : nextPageUrl,
        method == 'GET'? {} : params,
        'noForwordSlash',
        handleCountStateUpdate,
        newData,
        newTotalCount,
        newPaymentSummary
      );
    }

    console.log(newData)

    return { responseDataList: newData, paymentSummary: newPaymentSummary };
  } catch (error) {
    console.log(error, responseDataList)
    throw { error, responseDataList }
  }
};
